import { Button, Col, Form, Input, notification, Row, Switch } from "antd"
import { useEffect, useState } from "react";
import { addPlanApi, updatePlanApi } from "../../../config/Api";
import { API_ERR_MESSAGE, CHARACTER_PATTERN, CHARACTER_PATTERN_MESSAGE, PHONE_PATTERN, PHONE_PATTERN_MESSAGE } from "../../../config/constant";


export const AddPlanPricing = (props) => {
    const [form] = Form.useForm();
    const [planStatus, setPlanStatus] = useState(false)

    useEffect(() => {
        if (props.editPlanRecord) {
            let record = props.editPlanRecord
            setPlanStatus(record.plan_status)
            form.setFieldsValue({
                "name": record.name,
                "active_clients": record.active_clients,
                "price": record.price,
                // "plan_status": record.plan_status,
            })
        }
    }, [props.editPlanRecord])

    // handle submit event 
    //==============================
    const onFinish = (values) => {
        // const data = {
        //     "name": values.name,
        //     "active_clients": values.active_clients,
        //     "price": values.price,
        //     "plan_status": values.plan_status
        // }
        if (props.buttonName == "SAVE") {
            addPlanApi(values)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: "plan added successfully",
                        });
                        props.getListOfPlans()
                        props.setIsModalVisible(false)
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }
        else {
            updatePlanApi(props.editPlanRecord.id, values)
                .then((res) => {
                    if (res.status == 200) {
                        notification.success({
                            message: "Plan Update successfully",
                        });
                        props.getListOfPlans()
                        props.setIsModalVisible(false)
                    }
                })
                .catch((err) => {
                    notification.error({
                        message: API_ERR_MESSAGE,
                    });
                });
        }

    };
    const resetData = () => {
        form.resetFields()
    };


    return (
        <Form
            name="addPlanPricingForm"
            className="addPlanPricingForm"
            form={form}
            onFinish={onFinish}
        >
            <div className="logoSection">
                <h4 className="mb-0">{props.buttonName == 'UPDATE' ? 'Update' : "ADD"} Plan</h4>
            </div>
            <Row gutter={[16, { xs: 8, sm: 16, md: 24, lg: 8 }]} className="mt-3">
                <Col xs={24} md={12} xl={11} xxl={12}>
                    <label className="form-input-label">
                        Plan Name
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="name"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Plan name!",
                            },
                            {
                                pattern: CHARACTER_PATTERN,
                                message: CHARACTER_PATTERN_MESSAGE,
                            }
                        ]}
                    >
                        <Input placeholder="Enter Plan Name" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={8} md={12} lg={12} xl={11} xxl={12}>
                    <label className="form-input-label">
                        Active Clients
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="active_clients"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Active Clients!",
                            },
                            {
                                pattern: PHONE_PATTERN,
                                message: PHONE_PATTERN_MESSAGE,
                            }
                        ]}
                    >
                        <Input placeholder="Enter Active Clients" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                <Col xs={24} sm={8} md={12} lg={12} xl={11} xxl={12}>
                    <label className="form-input-label">
                        Plan price
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="price"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter Plan price!",
                            },
                            {
                                pattern: PHONE_PATTERN,
                                message: PHONE_PATTERN_MESSAGE,
                            }
                        ]}
                    >
                        <Input placeholder="Enter Plan price" className="mt-2 p-2" />
                    </Form.Item>
                </Col>
                {/* <Col xs={24} md={12} xl={11} xxl={12}>
                    <label className="form-input-label">
                        Users
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="plan_title"
                        rules={[
                            {
                                required: true,
                                message: "Please Enter total users!",
                            },
                        ]}
                        initialValue="1"
                    >
                        <Input disabled placeholder="Enter total users" className="mt-2 p-2" />
                    </Form.Item>
                </Col> */}
                <Col xs={24} sm={8} md={12} lg={8} xl={11} xxl={12}>
                    <label className="form-input-label">
                        Plan Status
                        <span className="asterik"> *</span>
                    </label>
                    <Form.Item
                        name="plan_status"
                        rules={[
                            {
                                required: true,
                                message: "Please select plan status!",
                            },
                        ]}
                        initialValue="1"
                    >
                        <Switch checked={planStatus} onChange={(e) => setPlanStatus(!planStatus)} />
                    </Form.Item>
                </Col>
                <Col span={24} className="text-center">
                    <Button htmlType="submit" className="submit-button b-0 rounded">
                        {props.buttonName}
                    </Button>
                    <Button onClick={() => resetData()} className="reset-button ms-4 b-0 rounded">
                        RESET
                    </Button>
                </Col>
            </Row>
        </Form>

    )
}